import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { DataQualityExceptionsPage } from "@/features/reports/data-quality-exceptions-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/jakosc-danych-wyjatki")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.analiza-zakupow-nowe-zam",
			location.pathname,
		);
	},
	validateSearch: (search: Record<string, unknown>) => {
		const now = new Date();
		const year = Number(search.year ?? now.getFullYear());

		return {
			year: Number.isFinite(year) ? year : now.getFullYear(),
		};
	},
	component: DataQualityExceptionsRoute,
});

function DataQualityExceptionsRoute() {
	const search = Route.useSearch();
	const navigate = Route.useNavigate();

	const currentYear = useMemo(() => search.year, [search.year]);

	return (
		<DataQualityExceptionsPage
			year={currentYear}
			onYearChange={(value) =>
				navigate({
					search: (prev) => ({
						...prev,
						year: value,
					}),
				})
			}
		/>
	);
}
